import { formatMoney } from 'common/src/other/currencyFormat';
import React from 'react';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import C2WithdrawsPanel from '../components/C2WithdrawsPanel';

const Withdraws = () => {
  const { t } = useTranslation();
  const settings = useSelector(state => state.settingsdata.settings);
  const { completeWithdraw, rejectWithdraw, getWalletWithdrawUserContext } = api;
  const dispatch = useDispatch();
  const withdrawdata = useSelector(state => state.withdrawdata);

  if (withdrawdata.loading) return <CircularLoading />;

  return (
    <C2WithdrawsPanel
      rows={withdrawdata.withdraws}
      settings={settings}
      title={t('Withdraw_title')}
      subtitle="El sistema valida cada solicitud y descuenta el saldo de la billetera. Paga solo las validadas y márcalas como pagadas; si hay un problema, recházala y el saldo vuelve a la billetera del usuario."
      emptyMessage="Cuando un usuario solicite retirar el saldo de su billetera, aparecerá aquí."
      csvFileName="retiros_billetera.csv"
      processedCaption="Histórico completo"
      formatAmount={(v) => formatMoney(v || 0, settings, { isRTL: !!settings.swipe_symbol })}
      onMarkPaid={(row) => dispatch(completeWithdraw(row))}
      onReject={(row, message) => dispatch(rejectWithdraw(row, message))}
      getUserContext={getWalletWithdrawUserContext}
      requireValidation
    />
  );
}

export default Withdraws;
